import SearchCustomer from "../../views/orders/form-ui/customer-info/SearchCustomer";
import {useSelector} from "react-redux";
import React, {useEffect} from "react";
import {useMutation} from "@tanstack/react-query";
import {getCustomerDetails} from "../../api/customers";
import {setOrderForm} from "../../store/slices/orderSlice";
import {useDispatch} from "react-redux";
import FormComponent from "../../views/orders/form-ui/FormComponent";
import {getOrderDetails} from "../../api/orders";
import {useLoaderData, useLocation, useParams} from "react-router-dom";
import {useNavigate} from "react-router";
import {checkPermission} from "../../util/auth";

export async function loaderOrderDetails({params}){
    const [orderDetails] = await Promise.all([
      getOrderDetails(params.id)
    ]);
    return {orderDetails};
}

const OrderForm = ()=>{
  const {orderForm} = useSelector(state => state.orders)
  const location = useLocation();
  const params = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate();
  useEffect(() => {
    if(!checkPermission(['ORDER_UPDATE']) && params.id){
      navigate("/no-access");
    }
    if(!checkPermission(['ORDER_CREATE']) && !params.id){
      navigate("/no-access");
    }
  }, [navigate]);

  useEffect(() => {
    dispatch(setOrderForm({customer:null, products:[]}))
  }, [location]);

  //For Edit order
  const loaderData = useLoaderData();
  if(loaderData) {
    dispatch(setOrderForm(loaderData.orderDetails?.data))
  }
  //For Edit order


  return (
    <>
      <FormComponent/>
    </>
  );
}

export default OrderForm